export const deleteLinkedAccount = (account_id) => {
    return fetch(`/customers/remove-link/${account_id}/`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};
